import Vue from 'vue';
import App from './App.vue';
import Vuesax from '@elbuenanvita/vuesax';
import '@elbuenanvita/vuesax/dist/vuesax.css';
import router from "./router";
import store from "./store";

import 'boxicons/css/boxicons.min.css';
import VueMeta from 'vue-meta';
import VueI18n from 'vue-i18n';
import LazyBackgroundImage from './components/LazyBackgroundImage';

const { DateTime } = require("luxon");
const { Temporal } = require("proposal-temporal");

Vue.use(Vuesax);
Vue.use(VueI18n);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });

Vue.component('lazy-background', LazyBackgroundImage);

import es_messages from './lang/es.json';
import eo_messages from './lang/eo.json';

// FIX: Leemos el idioma guardado por Pinia en localStorage (si no existe, usa 'es')
const savedPageStatus = JSON.parse(localStorage.getItem('pageStatus') || '{}');
const initialLanguage = savedPageStatus.language || 'es';

const i18n = new VueI18n({
    locale: initialLanguage,
    fallbackLocale: 'eo',
    messages: {
        es: es_messages,
        eo: eo_messages
    },
});

// Prototipos globales (esto está bien dejarlo aquí para Vue 2)
Vue.prototype.$luxonDateTime = DateTime;
Vue.prototype.$temporal = Temporal;
Vue.prototype.$statusesWatch = [
    { code: 0, title: "episode_watching.status.not_seen_title", message: "episode_watching.status.not_seen" },
    { code: 1, title: "episode_watching.status.seen_title", message: "episode_watching.status.seen" },
    { code: 2, title: "episode_watching.status.pending_title", message: "episode_watching.status.pending"}
];

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app');